import { useState, useCallback } from 'react';
import { getCarouselMaxIndex } from '../components/ui/CarouselNav';

const SWIPE_THRESHOLD_PX = 50;

/**
 * Touch/swipe handlers for carousel navigation.
 * @param {number} itemCount - Total number of carousel items
 * @param {boolean} isMobile - Whether mobile breakpoint (1 card vs 4 per view)
 * @param {function} setCurrentIndex - State setter for current index
 * @returns {{ onTouchStart: function, onTouchMove: function, onTouchEnd: function }}
 */
export function useCarouselSwipe(itemCount, isMobile, setCurrentIndex) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const onTouchStart = useCallback((e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  }, []);

  const onTouchMove = useCallback((e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  }, []);

  const onTouchEnd = useCallback(() => {
    if (touchStart == null || touchEnd == null) return;
    const distance = touchStart - touchEnd;
    const maxIndex = getCarouselMaxIndex(itemCount, isMobile);
    if (distance > SWIPE_THRESHOLD_PX) {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    } else if (distance < -SWIPE_THRESHOLD_PX) {
      setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
    }
  }, [touchStart, touchEnd, itemCount, isMobile, setCurrentIndex]);

  return { onTouchStart, onTouchMove, onTouchEnd };
}
